// import Glide from "@glidejs/glide";
export default class Reviews extends HTMLElement {
  constructor() {
    super();
    // this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
    this.initializeGlide();
  }

  render() {
    this.innerHTML = "";

    const imgBase = "/wp-content/themes/badaxe/img/v2/reviews/";
    const reviews = [
      {
        img: "serena-long-pic",
        srcSet: `${imgBase}/serena-long-pic-320w.jpg 320w, ${imgBase}/serena-long-pic-640w.jpg 640w, ${imgBase}/serena-long-pic.jpg`,
        sizes: "(max-width: 320px) 280px, (max-width: 640px) 640px, 100vw",
        name: "Serena Long",
        stars: 5,
        review:
          "The service that we got there was absolutely terrific! It was all fun and Grant was an absolute gem to have as our host. He kept us laughing and entertained for sure! We will definitely be coming back!!",
        url: "https://g.co/kgs/VEpGHc",
        alt: "Serena Long Review",
      },
      {
        img: "samantha-wisson-pic",
        srcSet: `${imgBase}/samantha-wisson-pic-320w.jpg 320w, ${imgBase}/samantha-wisson-pic-640w.jpg 640w, ${imgBase}/samantha-wisson-pic.jpg`,
        sizes: "(max-width: 320px) 320px, (max-width: 640px) 640px, 100vw",
        name: "Samantha Wisson",
        stars: 5,
        review:
          "Had so much fun my first time Axe Throwing! Brooke was such a fun coach and brought out the most fun competitive games for the fam! Amazing experience!",
        url: "https://g.co/kgs/svdTAJ",
        alt: "Samantha Wisson Review",
      },
      {
        img: "eric-ziegler-pic",
        srcSet: `${imgBase}/eric-ziegler-pic-320w.jpg 320w, ${imgBase}/eric-ziegler-pic-640w.jpg 640w, ${imgBase}/eric-ziegler-pic.jpg`,
        sizes: "(max-width: 320px) 320px, (max-width: 640px) 640px, 100vw",
        name: "Eric Ziegler",
        stars: 5,
        review:
          "This place is epic! They are so friendly and have a wide variety of hatchets, axes and knives to throw! The manager Shaun is awesome! Highly recommend this place for a party or a cool date night out!",
        url: "https://g.co/kgs/wP2b9W",
        alt: "Eric Ziegler Review",
      },
      {
        img: "andrea-jimenez-pic",
        name: "Andrea Jimenez",
        srcSet: `${imgBase}/andrea-jimenez-pic-320w.jpg 320w, ${imgBase}/andrea-jimenez-pic-640w.jpg 640w, ${imgBase}/andrea-jimenez-pic.jpg`,
        sizes: "(max-width: 320px) 320px, (max-width: 640px) 640px, 100vw",
        stars: 5,
        review:
          "This place was BAD AXE! I had my doubts but this was SO. MUCH. FUN. I wanna do this every week! The staff was friendly & helpful. Facility was clean & safe.",
        url: "https://g.co/kgs/7oyDdk",
        alt: "Andrea Jimenez Review",
      },
      {
        img: "katie-bowler-pic",
        srcSet: `${imgBase}/katie-bowler-pic-320w.jpg 320w, ${imgBase}/katie-bowler-pic-640w.jpg 640w, ${imgBase}/katie-bowler-pic.jpg`,
        sizes: "(max-width: 320px) 320px, (max-width: 640px) 640px, 100vw",
        name: "Katie Bowler",
        stars: 5,
        review:
          "We had a great time!  I loved how organized and fun the games were. Having our own personal axe throwing expert the whole time was so much fun! I would definitely recommend and definitely go again. I must get the blue dot!",
        url: "https://g.co/kgs/aj7xzR",
        alt: "Katie Bowler Review",
      },
    ];

    const container = document.createElement("div");
    container.className = "reviews-container";

    container.innerHTML = `
    <div class="glide" style="min-height: 300px;">
        <div class="mx-auto w-full items-center sm:items-start justify-between sm:justify-around glide__track" data-glide-el="track">
            <div class="glide__slides mx-4 sm:mx-auto px-4">
            ${reviews
        .map(
          (review) => `
                <div class="min-h-auto h-auto sm:h-auto border-gray-200 border-2 rounded-md my-4 mx-2 glide__slide">
                    <header class="flex flex-row flex-wrap items-center justify-center border-gray-300 border-b-2 p-2">
                        <div class="w-14">
                            <img 
                                src="${imgBase}${review.img}.jpg" 
                                alt="${review.alt}" 
                                width="40" 
                                height="40" 
                                class="rounded-full h-10 w-10"
                            />
                        </div>
                        <div class="flex-1 flex flex-col items-start justify-center">
                            <div class="font-semibold text-base sm:text-lg">${review.name
            }</div>
                            <div class="text-yellow-500 text-xl flex flex-row">${'<span class="mr-1">★</span>'.repeat(
              review.stars
            )}</div>
                        </div>
                        <div class="w-16 sm:w-20">
                            <a href="${review.url
            }" target="_blank" aria-label="${review.name}">
                            <img 
                                alt="Google Verified Reviews"
                                src="${imgBase}google-verified-reviews.png" 
                                sizes="(max-width: 600px) 600px, 100vw"
                                width="85"
                                height="45"
                                class="w-16 sm:w-20 h-auto" />
                            </a>
                        </div>
                    </header>

                    <div class="p-4 leading-relaxed text-sm sm:text-lg text-gray-600">
                        ${review.review}
                    </div>
                </div>`
        )
        .join("")}
            </div>
        </div>
      </div>
    `;

    this.appendChild(container);
  }

  initializeGlide() {
    this.initGlideInstance();
  }

  initGlideInstance() {
    const glideElement = this.querySelector(".glide");

    const reviewsCarousel = new Glide(glideElement, {
      type: "carousel",
      perView: 5,
      startAt: 0,
      focusAt: "center",
      gap: 10,
      hoverpause: true,
      bound: true,
      breakpoints: {
        800: {
          perView: 5,
        },
        480: {
          perView: 1,
        },
      },
    });

    reviewsCarousel.mount();
  }

  disconnectedCallback() { }
}
